import { render, staticRenderFns } from "./SelectorBoxes.vue?vue&type=template&id=9e82c4b8&scoped=true&"
import script from "./SelectorBoxes.vue?vue&type=script&lang=js&"
export * from "./SelectorBoxes.vue?vue&type=script&lang=js&"
import style0 from "./SelectorBoxes.vue?vue&type=style&index=0&id=9e82c4b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e82c4b8",
  null
  
)

export default component.exports